import { getCountryAlpha3, Province, Region } from "@nemuru-eng/js-api-client";
import { geocoderToAddressFieldsMapper } from "../mappers/geocoderToAddressFieldsMapper";

export const useAddressFormFields = ({ setValue, trigger }) => {
  const updateProvinceAndRegionFromPostalCode = (postalCode) => {
    try {
      const province = Province.createFromPostalCode(postalCode);
      const region = Region.createFromPostalCode(postalCode);
      setValue("address.province", province.longName);
      setValue("address.provinceShortName", province.shortName);
      setValue("address.region", region.longName);
      setValue("address.regionShortName", region.shortName);
    } catch (error) {
      console.log(error);
    }
  };

  const updateFormFieldsFromGeocode = (geocode) => {
    const {
      streetName,
      streetNumber,
      postalCode,
      city,
      province,
      provinceShortName,
      regionLongName,
      regionShortName,
      country,
      countryLongName,
    } = geocoderToAddressFieldsMapper(geocode);

    setValue("address.address", geocode.formatted_address, {
      shouldDirty: true,
    });
    setValue("address.streetName", streetName);
    setValue("address.streetNumber", streetNumber);
    setValue("address.city", city);
    setValue("address.province", province);
    setValue("address.country", getCountryAlpha3(country));
    setValue("address.postalCode", postalCode, { shouldValidate: true });
    setValue("address.region", regionLongName);
    setValue("address.regionShortName", regionShortName);
    setValue("address.countryLongName", countryLongName);
    setValue("address.provinceShortName", provinceShortName);
    setValue("address.latitude", geocode.geometry.location.lat());
    setValue("address.longitude", geocode.geometry.location.lng());
    trigger();
  };
  return {
    updateFormFieldsFromGeocode,
    updateProvinceAndRegionFromPostalCode,
  };
};
